import { ReduxDispatch } from "models/ReduxProps";
import ActionUtility from "utilities/ActionUtility";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import PreventiviConFirmaDigitaleModel from "./models/PreventiviConFirmaDigitaleModel";
import PreventiviInScadenzaModel from "./models/PreventiviInScadenzaModel";
import NotificheEffect from "./NotificheEffect";
import AppointmentModel from "./models/AppointmentModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | PreventiviInScadenzaModel
    | PreventiviConFirmaDigitaleModel
    | AppointmentModel;

export default class NotificheAction {
    public static readonly REQUEST_SIMULAZIONE_NOTIFICHE_GET_EXPIRING_ESTIMATE: string =
        "NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_EXPIRING_ESTIMATE";
    public static readonly REQUEST_SIMULAZIONE_NOTIFICHE_GET_EXPIRING_ESTIMATE_FINISHED: string =
        "NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_EXPIRING_ESTIMATE_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_NOTIFICHE_GET_DIGITAL_SIGNED_DOCUMENTS: string =
        "NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_DIGITAL_SIGNED_DOCUMENTS";
    public static readonly REQUEST_SIMULAZIONE_NOTIFICHE_GET_DIGITAL_SIGNED_DOCUMENTS_FINISHED: string =
        "NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_DIGITAL_SIGNED_DOCUMENTS_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_NOTIFICHE_GET_APPOINTMENTS: string =
        "NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_APPOINTMENTS";
    public static readonly REQUEST_SIMULAZIONE_NOTIFICHE_GET_APPOINTMENTS_FINISHED: string =
        "NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_APPOINTMENTS_FINISHED";

    public static getExpiringEstimateNotification(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<PreventiviInScadenzaModel>(
                dispatch,
                NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_EXPIRING_ESTIMATE,
                NotificheEffect.getExpiringEstimateNotification
            );
        };
    }

    public static getDigitalSignedDocumentNotification(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<PreventiviConFirmaDigitaleModel>(
                dispatch,
                NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_DIGITAL_SIGNED_DOCUMENTS,
                NotificheEffect.getDigitalSignedDocumentNotification
            );
        };
    }

    public static getTodayAppointments(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AppointmentModel>(
                dispatch,
                NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_APPOINTMENTS,
                NotificheEffect.getAppointmentNotification
            );
        };
    }
}
